//@ts-check
import request from '../request';
/**
 * Run a diagram (.edx) an return its result
 * @param {{ workspace: string; path: string; parameters: {[name: string]: string} }} options
 * @return {Promise<string>} xml content
 */

export var get = function get(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      parameters = _ref.parameters;
  return request({
    url: '/api/v2/data',
    method: 'POST',
    data: {
      InputSettings: {
        Diagram: {
          Workspace: workspace,
          Path: path,
          DiagramParameters: Object.keys(parameters).map(function (k) {
            return {
              Name: k,
              Value: parameters[k]
            };
          })
        }
      }
    }
  });
};
export default {
  get: get
};